import { Component, EventEmitter, Output } from '@angular/core';

import { Language } from '@interfaces';

@Component({
  selector: 'app-login-api-unavailable-view',
  templateUrl: './login-api-unavailable-view.component.html',
  styleUrls: ['../shared-styles/login-device-view.component.scss', './login-api-unavailable-view.component.scss'],
  standalone: false,
})
export class LoginApiUnavailableViewComponent {
  @Output() public userLangChanged = new EventEmitter<Language>();
}
